/*
 * PBS Tiered Pricing Widget v2.1
 * Renders Blanks/Decorated pricing table under retail price.
 * Prices from PBS_PRICING are coded (G) = master sheet * 1.20
 */
(function() {
  var QTY = ['1-4','5-9','10-24','25-74','75-199','200+'];
  var MARKUP = 1.20;
  var SUFFIXES = ['-PBS','-U-PBS','-DE-PBS','-AMZ-PBS','-CR-PBS','-1-PBS','-FBA','-CA','-NOB','-EX','-U','-DE','-AMZ'];

  function stripSku(sku) {
    if (!sku) return '';
    var s = sku.toUpperCase().trim();
    for (var i = 0; i < SUFFIXES.length; i++) {
      if (s.length > SUFFIXES[i].length && s.endsWith(SUFFIXES[i])) {
        s = s.substring(0, s.length - SUFFIXES[i].length);
        break;
      }
    }
    return s;
  }

  function fmt(n) {
    return '\x24' + (n * MARKUP).toFixed(2) + ' (G)';
  }

  function buildWidget(blanks, decorated) {
    var f = "font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;";
    var uid = 'pbs-' + Math.random().toString(36).substring(2, 8);
    var btId = uid + '-bt', dtId = uid + '-dt', bfId = uid + '-bf', dfId = uid + '-df';
    var bbId = uid + '-bb', dbId = uid + '-db';

    function makeTable(prices, id) {
      var hs = '';
      var cs = '';
      for (var i = 0; i < QTY.length; i++) {
        hs += '<th style="padding:8px 10px;font-size:12px;font-weight:600;color:#86868b;text-align:center;white-space:nowrap;border-bottom:1px solid #e5e5e5;' + f + '">' + QTY[i] + '</th>';
        cs += '<td style="padding:10px;font-size:14px;font-weight:600;color:#1d1d1f;text-align:center;white-space:nowrap;' + f + '">' + fmt(prices[i]) + '</td>';
      }
      return '<table id="' + id + '" style="width:100%;border-collapse:collapse;"><tr>' + hs + '</tr><tr>' + cs + '</tr></table>';
    }

    var sw = function(activeBtn, inactiveBtn, showTbl, hideTbl, showFn, hideFn) {
      return "document.getElementById('" + activeBtn + "').style.background='#f5f5f7';document.getElementById('" + activeBtn + "').style.color='#1d1d1f';" +
        "document.getElementById('" + inactiveBtn + "').style.background='#fff';document.getElementById('" + inactiveBtn + "').style.color='#86868b';" +
        "document.getElementById('" + showTbl + "').style.display='table';document.getElementById('" + hideTbl + "').style.display='none';" +
        "document.getElementById('" + showFn + "').style.display='block';document.getElementById('" + hideFn + "').style.display='none';";
    };

    var html = '<div data-pbs-widget="2" style="max-width:620px;margin:16px 0;' + f + 'border:1px solid #d2d2d7;border-radius:12px;overflow:hidden;background:#fff;">' +
      '<div style="display:flex;border-bottom:1px solid #d2d2d7;">' +
        '<button id="' + bbId + '" onclick="' + sw(bbId, dbId, btId, dtId, bfId, dfId) + '" style="flex:1;padding:10px;font-size:13px;font-weight:600;border:none;cursor:pointer;background:#f5f5f7;color:#1d1d1f;' + f + '">Blanks</button>' +
        '<button id="' + dbId + '" onclick="' + sw(dbId, bbId, dtId, btId, dfId, bfId) + '" style="flex:1;padding:10px;font-size:13px;font-weight:600;border:none;cursor:pointer;background:#fff;color:#86868b;' + f + '">Decorated</button>' +
      '</div>' +
      makeTable(blanks, btId) +
      '<div id="' + dtId + '" style="display:none;">' + makeTable(decorated, dtId + '-t') + '</div>' +
      '<p id="' + bfId + '" style="margin:0;padding:6px 12px;font-size:11px;color:#86868b;white-space:nowrap;' + f + '">Blank product \u2014 no decoration. Price does not include shipping.</p>' +
      '<p id="' + dfId + '" style="margin:0;padding:6px 12px;font-size:11px;color:#86868b;white-space:nowrap;display:none;' + f + '">Includes full color imprint. Additional charges may apply for extra locations and personalization. Set Up is \x2490.00 (waived after 24 units).</p>' +
      '</div>';

    return html;
  }

  function init() {
    var mount = document.getElementById('pbs-pricing-mount');
    if (!mount) return;
    var sku = mount.getAttribute('data-sku');
    if (!sku) return;
    var pricing = window.PBS_PRICING;
    if (!pricing) return;
    var baseSku = stripSku(sku);
    var entry = pricing[baseSku];
    if (!entry) {
      var tryKeys = [baseSku, baseSku + '-FBA', baseSku + '-AMZ', baseSku + '-DE', baseSku + '-EX', baseSku + '-CA'];
      for (var i = 0; i < tryKeys.length; i++) {
        if (pricing[tryKeys[i]]) { entry = pricing[tryKeys[i]]; break; }
      }
    }
    if (!entry || !entry.b || !entry.d || entry.b.length < 6 || entry.d.length < 6) {
      mount.style.display = 'none';
      return;
    }
    mount.innerHTML = buildWidget(entry.b, entry.d);
    var oldWidgets = document.querySelectorAll('[data-pbs-widget="1"]');
    for (var i = 0; i < oldWidgets.length; i++) { oldWidgets[i].style.display = 'none'; }
    var oldFallback = document.getElementById('pbs-pricing-fallback');
    if (oldFallback) oldFallback.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();